import React from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';

import { Button, Space, FileItem, Text, theme } from 'components';

import type { RejectedDocumentTask } from '@/app-package';
import ListingSection from './ListingSection';
import TaskLayout from './TaskLayout';

type RejectedDocumentItemProps = { itemData: RejectedDocumentTask['data'] };

const RejectedDocumentItem: React.FC<RejectedDocumentItemProps> = ({
  itemData,
}) => {
  const fileItem = {
    uid: '',
    filename: itemData.name,
    mimetype: itemData.fileType,
  };
  return (
    <TaskLayout
      title="Document Rejected"
      content={
        <Space direction="vertical">
          <ListingSection
            data-cy="doc-rejected-listing-data"
            listing={{
              line1: itemData.line1,
              line2: itemData.line2,
              thumbnail: itemData.thumbnail,
            }}
          />
          <FileItem data-cy="doc-rejected-file" file={fileItem} />
          <StyledReason data-cy="doc-rejected-reason" ellipsis>
            &ldquo;{itemData.reason}&rdquo;
          </StyledReason>
        </Space>
      }
      buttons={
        <Link
          data-cy="doc-rejected-link"
          to={`/listing/${itemData.listingId}/documents`}
        >
          <Button size="small">Manage Documents</Button>
        </Link>
      }
      dataCy="doc-rejected-task-item"
    />
  );
};

export default RejectedDocumentItem;

const StyledReason = styled(Text)`
  && {
    color: ${theme.gray7};
  }
`;
